import { render, staticRenderFns } from "./QNotice.vue?vue&type=template&id=66efea85&scoped=true&"
import script from "./QNotice.vue?vue&type=script&lang=js&"
export * from "./QNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66efea85",
  null
  
)

export default component.exports